import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useGame } from "../context/GameContext";
import socketService from "../services/socketService";
import Lobby from "./Lobby";
import Game from "./Game";
import GameOver from "./GameOver";

const RoomPage = () => {
  const { roomId: urlRoomId } = useParams();
  const { roomId, gameState } = useGame();
  const navigate = useNavigate();

  // Auto-join the room from URL if not already in it
  useEffect(() => {
    if (urlRoomId && !roomId) {
      // Check if we have an active session for this room
      const savedRoomId = localStorage.getItem("roomId");
      const savedPlayerId = localStorage.getItem("playerId");

      if (savedRoomId === urlRoomId && savedPlayerId) {
        // Reconnect to existing session
        socketService.loadSavedPlayerId();
        socketService.enableAutoReconnect();
        socketService.manualReconnect();
      } else {
        // New join - will be handled by Home page redirect
        // The user needs to pick avatar/pseudo first
        navigate("/?room=" + urlRoomId);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [urlRoomId, roomId, navigate]);

  if (!roomId) {
    return (
      <div className="min-h-screen flex items-center justify-center p-4">
        <div className="bg-white rounded-lg shadow-2xl p-8">
          <p className="text-gray-600">Connexion à la room...</p>
        </div>
      </div>
    );
  }

  switch (gameState) {
    case "entering_characters":
    case "playing":
      return <Game />;
    case "finished":
      return <GameOver />;
    default:
      return <Lobby />;
  }
};

export default RoomPage;
